import { useCallback } from "react";
import { useGlobalLocalContext } from "src/storage/localStorage.ts";
import { pitToHumanReadable } from "@utils/time";

/**
 * Reactive wrapper over pitToHumanReadable that injects the user's chosen tz
 * offset from the store, so displayed event times follow the timezone selector.
 * Use for real event timestamps; render logical PIT labels literally instead.
 */
export const usePitToHumanReadable = () => {
  const tz = useGlobalLocalContext((state) => state.tz);

  return useCallback(
    (
      pit: string | Date | undefined,
      shouldSplit = false,
      format: Intl.DateTimeFormatOptions = {}
    ) => pitToHumanReadable(pit, shouldSplit, format, tz),
    [tz]
  );
};
